export function UserCheckIcon() {
    return (
        <div
            style={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                backgroundColor: "#E9EFF4",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="20"
                viewBox="0 0 24 20"
                fill="none"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.57895 15.7576L11.3684 12.1939C10.8758 12.1455 10.5095 12.1212 10.1053 12.1212C6.73263 12.1212 0 13.7455 0 16.9697V19.3939H11.3684L7.57895 15.7576ZM10.1053 9.69697C12.8968 9.69697 15.1579 7.52727 15.1579 4.84848C15.1579 2.1697 12.8968 0 10.1053 0C7.31368 0 5.05263 2.1697 5.05263 4.84848C5.05263 7.52727 7.31368 9.69697 10.1053 9.69697Z"
                    fill="#22638D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.7516 20L11.3684 15.7576L13.1368 14.0485L15.7516 16.5697L22.2316 10.303L24 12.0121L15.7516 20Z"
                    fill="#22638D"
                />
            </svg>
        </div>
    );
}